import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = {
    key: 0,
    class: "form-details"
};
const _hoisted_3 = {
    key: 0,
    class: "x_title x-header"
};
const _hoisted_4 = { class: "clearfix tile_count tile-emails-count row" };
const _hoisted_5 = { class: "col-xl tile_stats_count unknown" };
const _hoisted_6 = ["title"];
const _hoisted_7 = { class: "count clearfix" };
const _hoisted_8 = { class: "col-xl tile_stats_count unknown" };
const _hoisted_9 = ["title"];
const _hoisted_10 = { class: "count clearfix" };
const _hoisted_11 = { class: "col-xl tile_stats_count healthy" };
const _hoisted_12 = { class: "clearfix" };
const _hoisted_13 = { class: "count clearfix" };
const _hoisted_14 = { class: "col-xl tile_stats_count critical" };
const _hoisted_15 = { class: "clearfix" };
const _hoisted_16 = { class: "count clearfix" };
const _hoisted_17 = { class: "col-xl tile_stats_count critical" };
const _hoisted_18 = { class: "clearfix" };
const _hoisted_19 = { class: "count clearfix" };
const _hoisted_20 = { class: "clearfix" };
const _hoisted_21 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_22 = { class: "input-group top_search" };
const _hoisted_23 = { class: "input-group-btn" };
const _hoisted_24 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_25 = { class: "input-group top_search" };
const _hoisted_26 = { class: "col-xs-12 col-sm-12 col-md-2" };
const _hoisted_27 = { class: "input-group top_search" };
const _hoisted_28 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_29 = {
    key: 0,
    class: "btn-group pw100"
};
const _hoisted_30 = {
    key: 1,
    class: "row left-10 right-10"
};
const _hoisted_31 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_32 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_33 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12"
};
const _hoisted_34 = { class: "clearfix data-grid-top-pagination" };
const _hoisted_35 = { class: "float-end" };
const _hoisted_36 = { class: "float-end hidden-xs record-count" };
const _hoisted_37 = { class: "col-xs-12 col-sm-12" };
const _hoisted_38 = { class: "card bg-white data-grid notifications-grid detached overflow-x-auto" };
const _hoisted_39 = {
    id: "notificationsTable",
    class: "table table-hover border-collapse-separate bottom0"
};
const _hoisted_40 = { class: "max-width300" };
const _hoisted_41 = { class: "hidden-sm" };
const _hoisted_42 = { class: "hidden-sm" };
const _hoisted_43 = { class: "hidden-sm" };
const _hoisted_44 = { class: "hidden-sm" };
const _hoisted_45 = { class: "hidden-sm text-center" };
const _hoisted_46 = ["onClick"];
const _hoisted_47 = { class: "hidden-sm" };
const _hoisted_48 = { class: "clearfix visible-sm" };
const _hoisted_49 = { class: "blue lead" };
const _hoisted_50 = { class: "clearfix" };
const _hoisted_51 = { class: "clearfix" };
const _hoisted_52 = { class: "hidden-sm" };
const _hoisted_53 = { class: "hidden-sm" };
const _hoisted_54 = { class: "hidden-sm" };
const _hoisted_55 = { class: "hidden-sm" };
const _hoisted_56 = { class: "hidden-sm text-center" };
const _hoisted_57 = {
    key: 0,
    class: "fa fa-check green",
    "aria-hidden": "true"
};
const _hoisted_58 = {
    key: 1,
    class: "fa fa-times red",
    "aria-hidden": "true"
};
const _hoisted_59 = { key: 0 };
const _hoisted_60 = { class: "clearfix" };
const _hoisted_61 = { class: "col-sm-12 col-xs-12 col-md-12 bottom10" };
const _hoisted_62 = { class: "notification-subject" };
const _hoisted_63 = { class: "col-sm-12 col-xs-12 col-md-12 bottom10" };
const _hoisted_64 = ["srcdoc"];
const _hoisted_65 = {
    key: 1,
    class: "notification-content"
};
const _hoisted_66 = { class: "float-end float-start-sm" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b, _c;
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_button = _resolveComponent("b-button");
    const _component_flat_pickr = _resolveComponent("flat-pickr");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_modal = _resolveComponent("b-modal");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    const _directive_b_tooltip = _resolveDirective("b-tooltip");
    const _directive_cloud_only = _resolveDirective("cloud-only");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.showTitle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[9] || (_cache[9] = [
                    _createElementVNode("div", { class: "form-title" }, [
                        _createElementVNode("h2", null, "\r\n\t\t\t\t\tNotifications\r\n\t\t\t\t")
                    ], -1 /* CACHED */)
                ]))]))
            : _createCommentVNode("v-if", true),
        _cache[70] || (_cache[70] = _createTextVNode()),
        _createElementVNode("div", {
            class: _normalizeClass({ 'form-contents': !_ctx.showSummary })
        }, [
            (_ctx.showSummary && _ctx.query.companyId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _withDirectives((_openBlock(), _createElementBlock("div", {
                                title: 'Daily limit: ' + ((_b = (_a = _ctx.summary) === null || _a === void 0 ? void 0 : _a.notificationPreferences) === null || _b === void 0 ? void 0 : _b.maxDailyAlarmEmailLimitPerSystem)
                            }, [
                                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "clearfix" }, [
                                    _createElementVNode("i", { class: "fa fa-calculator" }),
                                    _createTextVNode(" Emails sent last 24 hours\r\n\t\t\t\t\t\t\t")
                                ], -1 /* CACHED */)),
                                _cache[11] || (_cache[11] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.numberOfEmailsSentToday), 1 /* TEXT */)
                            ], 8 /* PROPS */, _hoisted_6)), [
                                [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    {
                                        hover: true,
                                        body: true,
                                        bottom: true
                                    }
                                ]
                            ])
                        ]),
                        _cache[20] || (_cache[20] = _createTextVNode()),
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _withDirectives((_openBlock(), _createElementBlock("div", {
                                title: 'Daily limit: ' + ((_c = _ctx.summary.notificationPreferences) === null || _c === void 0 ? void 0 : _c.maxDailyAlarmSmsLimitPerSystem)
                            }, [
                                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "clearfix" }, [
                                    _createElementVNode("i", { class: "fa fa-calculator" }),
                                    _createTextVNode(" SMSs sent last 24 hours\r\n\t\t\t\t\t\t\t")
                                ], -1 /* CACHED */)),
                                _cache[13] || (_cache[13] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.numberOfSmsSentToday), 1 /* TEXT */)
                            ], 8 /* PROPS */, _hoisted_9)), [
                                [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    {
                                        hover: true,
                                        body: true,
                                        bottom: true
                                    }
                                ]
                            ])
                        ])), [
                            [_directive_cloud_only]
                        ]),
                        _cache[21] || (_cache[21] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "clearfix" }, [
                                    _createElementVNode("i", { class: "fa fa-clock-o" }),
                                    _createTextVNode(" Last summary email\r\n\t\t\t\t\t\t\t")
                                ], -1 /* CACHED */)),
                                _cache[15] || (_cache[15] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.whenLastSystemSummaryEmailCreated), 1 /* TEXT */)
                            ])
                        ]),
                        _cache[22] || (_cache[22] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "clearfix" }, [
                                    _createElementVNode("i", { class: "fa fa-clock-o" }),
                                    _createTextVNode(" Last alarm email\r\n\t\t\t\t\t\t\t")
                                ], -1 /* CACHED */)),
                                _cache[17] || (_cache[17] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.whenLastAlarmEmailCreated), 1 /* TEXT */)
                            ])
                        ]),
                        _cache[23] || (_cache[23] = _createTextVNode()),
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "clearfix" }, [
                                    _createElementVNode("i", { class: "fa fa-clock-o" }),
                                    _createTextVNode(" Last alarm SMS\r\n\t\t\t\t\t\t\t")
                                ], -1 /* CACHED */)),
                                _cache[19] || (_cache[19] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.whenLastAlarmSmsCreated), 1 /* TEXT */)
                            ])
                        ])), [
                            [_directive_cloud_only]
                        ])
                    ])
                ]))
                : _createCommentVNode("v-if", true),
            _cache[61] || (_cache[61] = _createTextVNode()),
            _createElementVNode("div", {
                class: _normalizeClass({ 'row': !_ctx.showSummary, 'x_content': _ctx.showSummary })
            }, [
                _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                            _createVNode(_component_b_form_input, {
                                type: "text",
                                modelValue: _ctx.query.keywords,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                                modelModifiers: { trim: true },
                                placeholder: "Search for...",
                                onKeyup: _withKeys(_ctx.search, ["enter"]),
                                required: ""
                            }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                            _cache[25] || (_cache[25] = _createTextVNode()),
                            _createElementVNode("span", _hoisted_23, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-default",
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.search && _ctx.search(...args)))
                                }, [...(_cache[24] || (_cache[24] = [
                                        _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* CACHED */)
                                    ]))])
                            ])
                        ])
                    ]),
                    _cache[35] || (_cache[35] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_multiselect, {
                                modelValue: _ctx.selectedCompanyId,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.selectedCompanyId) = $event)),
                                options: _ctx.companies,
                                "track-by": "value",
                                label: "text",
                                showLabels: false,
                                placeholder: "All companies",
                                class: "multiselect-small"
                            }, {
                                noResult: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue", "options"])
                        ])
                    ]),
                    _cache[36] || (_cache[36] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_26, [
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createVNode(_component_multiselect, {
                                modelValue: _ctx.selectedChannelId,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.selectedChannelId) = $event)),
                                options: _ctx.channels,
                                "track-by": "value",
                                label: "text",
                                showLabels: false,
                                placeholder: "All types",
                                class: "multiselect-small"
                            }, {
                                noResult: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue", "options"])
                        ])), [
                            [_directive_cloud_only]
                        ])
                    ]),
                    _cache[37] || (_cache[37] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_28, [
                        (!_ctx.showDatePickers)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateFilterOptions, (item, idx) => {
                                    return (_openBlock(), _createBlock(_component_b_button, {
                                        class: "pw100",
                                        disabled: _ctx.working,
                                        key: idx,
                                        variant: _ctx.dateFilterOption == item ? 'primary' : 'outline-secondary',
                                        onClick: ($event) => (_ctx.setDateFilterOption(item))
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled", "variant", "onClick"]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]))
                            : _createCommentVNode("v-if", true),
                        _cache[34] || (_cache[34] = _createTextVNode()),
                        (_ctx.showDatePickers)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                _createElementVNode("div", _hoisted_31, [
                                    _createVNode(_component_b_input_group, {
                                        class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.startDateInvalid ? 'is-invalid' : ''])
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_flat_pickr, {
                                                class: "form-control",
                                                modelValue: _ctx.query.whenCreatedFrom,
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.query.whenCreatedFrom) = $event)),
                                                config: _ctx.datePickerConfig,
                                                placeholder: "From date",
                                                disabled: _ctx.working
                                            }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                            _cache[29] || (_cache[29] = _createTextVNode()),
                                            _createVNode(_component_b_input_group_append, { class: "input-group-btn" }, {
                                                default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                                        _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
                                                            _createElementVNode("button", {
                                                                type: "button",
                                                                class: "btn btn-default",
                                                                "data-toggle": ""
                                                            }, [
                                                                _createElementVNode("i", { class: "fa fa-calendar" })
                                                            ])
                                                        ], -1 /* CACHED */)
                                                    ]))]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["class"])
                                ]),
                                _cache[33] || (_cache[33] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_32, [
                                    _createVNode(_component_b_input_group, {
                                        class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.endDateInvalid ? 'is-invalid' : ''])
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_flat_pickr, {
                                                class: "form-control",
                                                modelValue: _ctx.query.whenCreatedTo,
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.query.whenCreatedTo) = $event)),
                                                config: _ctx.datePickerConfig,
                                                placeholder: "Until date",
                                                disabled: _ctx.working
                                            }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                            _cache[32] || (_cache[32] = _createTextVNode()),
                                            _createVNode(_component_b_input_group_append, { class: "input-group-btn" }, {
                                                default: _withCtx(() => [
                                                    _cache[30] || (_cache[30] = _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
                                                        _createElementVNode("button", {
                                                            type: "button",
                                                            class: "btn btn-default",
                                                            "data-toggle": ""
                                                        }, [
                                                            _createElementVNode("i", { class: "fa fa-calendar" })
                                                        ])
                                                    ], -1 /* CACHED */)),
                                                    _cache[31] || (_cache[31] = _createTextVNode()),
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "btn btn-secondary",
                                                        onClick: _cache[6] || (_cache[6] =
                                                            //@ts-ignore
                                                            (...args) => (_ctx.resetDateFilterOption && _ctx.resetDateFilterOption(...args)))
                                                    }, "\r\n\t\t\t\t\t\t\t\t\t\t\t...\r\n\t\t\t\t\t\t\t\t\t\t")
                                                ]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["class"])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _cache[57] || (_cache[57] = _createTextVNode()),
                _cache[58] || (_cache[58] = _createElementVNode("div", { class: "clearfix" }, null, -1 /* CACHED */)),
                _cache[59] || (_cache[59] = _createTextVNode()),
                (_ctx.searchAttempted)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                                _createVNode(_component_b_pagination, {
                                    class: "float-end",
                                    modelValue: _ctx.query.pageNo,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.query.pageNo) = $event)),
                                    "per-page": _ctx.query.pageSize,
                                    "total-rows": _ctx.data.recordCount,
                                    "hide-ellipsis": true,
                                    disabled: _ctx.working
                                }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                            ]),
                            _cache[38] || (_cache[38] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_36, "\r\n\t\t\t\t\t\t\tItems: " + _toDisplayString(_ctx.data.recordCount), 1 /* TEXT */)
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                _cache[60] || (_cache[60] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("table", _hoisted_39, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", _hoisted_40, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'whenAttempted', title: 'Time', visible: true }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ]),
                                    _cache[39] || (_cache[39] = _createTextVNode()),
                                    _createElementVNode("th", _hoisted_41, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'Subject', title: 'Subject' }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ]),
                                    _cache[40] || (_cache[40] = _createTextVNode()),
                                    _createElementVNode("th", _hoisted_42, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'ContactName', title: 'Contact Name' }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ]),
                                    _cache[41] || (_cache[41] = _createTextVNode()),
                                    _createElementVNode("th", _hoisted_43, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'DestinationAddress', title: 'To' }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ]),
                                    _cache[42] || (_cache[42] = _createTextVNode()),
                                    _createElementVNode("th", _hoisted_44, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'NotificationChannelName', title: 'Type' }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ]),
                                    _cache[43] || (_cache[43] = _createTextVNode()),
                                    _createElementVNode("th", _hoisted_45, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'IsSuccessful', title: 'Sucessfully Sent' }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ])
                                ])
                            ]),
                            _cache[55] || (_cache[55] = _createTextVNode()),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        class: _normalizeClass(['alarm pointer', _ctx.alarmClass(item)]),
                                        onClick: ($event) => (_ctx.view(item))
                                    }, [
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.whenAttemptedTimeString(item)), 1 /* TEXT */),
                                            _cache[48] || (_cache[48] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_48, [
                                                _createElementVNode("span", _hoisted_49, _toDisplayString(item.subject), 1 /* TEXT */),
                                                _cache[46] || (_cache[46] = _createTextVNode()),
                                                _createElementVNode("div", _hoisted_50, [
                                                    _cache[44] || (_cache[44] = _createElementVNode("i", { class: "fa fa-clock-o" }, null, -1 /* CACHED */)),
                                                    _createTextVNode(" " + _toDisplayString(_ctx.whenAttemptedTimeString(item)), 1 /* TEXT */)
                                                ]),
                                                _cache[47] || (_cache[47] = _createTextVNode()),
                                                _createElementVNode("div", _hoisted_51, [
                                                    _cache[45] || (_cache[45] = _createElementVNode("i", { class: "fa fa-paper-plane" }, null, -1 /* CACHED */)),
                                                    _createTextVNode(" " + _toDisplayString(item.destinationAddress), 1 /* TEXT */)
                                                ])
                                            ])
                                        ]),
                                        _cache[49] || (_cache[49] = _createTextVNode()),
                                        _createElementVNode("td", _hoisted_52, _toDisplayString(item.subject), 1 /* TEXT */),
                                        _cache[50] || (_cache[50] = _createTextVNode()),
                                        _createElementVNode("td", _hoisted_53, _toDisplayString(item.contactName), 1 /* TEXT */),
                                        _cache[51] || (_cache[51] = _createTextVNode()),
                                        _createElementVNode("td", _hoisted_54, _toDisplayString(item.destinationAddress), 1 /* TEXT */),
                                        _cache[52] || (_cache[52] = _createTextVNode()),
                                        _createElementVNode("td", _hoisted_55, _toDisplayString(item.notificationChannelName), 1 /* TEXT */),
                                        _cache[53] || (_cache[53] = _createTextVNode()),
                                        _createElementVNode("td", _hoisted_56, [
                                            (item.isSuccessful)
                                                ? (_openBlock(), _createElementBlock("i", _hoisted_57))
                                                : (_openBlock(), _createElementBlock("i", _hoisted_58))
                                        ])
                                    ], 10 /* CLASS, PROPS */, _hoisted_46));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ]),
                            _cache[56] || (_cache[56] = _createTextVNode()),
                            _createElementVNode("tfoot", null, [
                                (_ctx.noData)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_59, [...(_cache[54] || (_cache[54] = [
                                            _createElementVNode("td", {
                                                class: "text-center hidden-sm",
                                                colspan: "5"
                                            }, [
                                                _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
                                            ], -1 /* CACHED */),
                                            _createTextVNode(),
                                            _createElementVNode("td", { class: "text-center visible-sm" }, [
                                                _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
                                            ], -1 /* CACHED */)
                                        ]))]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.searchAttempted]
                ])
            ], 2 /* CLASS */)
        ], 2 /* CLASS */),
        _cache[71] || (_cache[71] = _createTextVNode()),
        _createVNode(_component_b_modal, {
            class: "modal-form-lg",
            id: "notification_popup",
            modelValue: _ctx.viewingNotification,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.viewingNotification) = $event)),
            "header-bg-variant": "normal",
            size: "xl"
        }, {
            title: _withCtx(() => [...(_cache[62] || (_cache[62] = [
                    _createTextVNode("\r\n\t\t\t\tNotification\r\n\t\t\t", -1 /* CACHED */)
                ]))]),
            footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_66, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "secondary",
                        onClick: _ctx.cancel
                    }, {
                        default: _withCtx(() => [...(_cache[67] || (_cache[67] = [
                                _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                _createTextVNode(" Close\r\n\t\t\t\t\t", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])
            ]),
            default: _withCtx(() => [
                _cache[68] || (_cache[68] = _createTextVNode()),
                _createVNode(_component_b_container, { clearfix: "" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("div", _hoisted_61, [
                                _createElementVNode("h1", _hoisted_62, _toDisplayString(_ctx.notification.subject), 1 /* TEXT */),
                                _cache[65] || (_cache[65] = _createTextVNode()),
                                _createElementVNode("h2", null, [
                                    _cache[63] || (_cache[63] = _createElementVNode("i", { class: "fa fa-clock-o" }, null, -1 /* CACHED */)),
                                    _createTextVNode("  " + _toDisplayString(_ctx.whenAttemptedTimeString(_ctx.notification)) + " ", 1 /* TEXT */),
                                    _cache[64] || (_cache[64] = _createElementVNode("i", { class: "fa fa-paper-plane" }, null, -1 /* CACHED */)),
                                    _createTextVNode("  " + _toDisplayString(_ctx.notification.destinationAddress), 1 /* TEXT */)
                                ])
                            ]),
                            _cache[66] || (_cache[66] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_63, [
                                (_ctx.notification.notificationChannelId == 1)
                                    ? (_openBlock(), _createElementBlock("iframe", {
                                        key: 0,
                                        id: "notiifcation_content",
                                        class: "notification",
                                        srcdoc: _ctx.notification.content,
                                        sandbox: ""
                                    }, null, 8 /* PROPS */, _hoisted_64))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_65, _toDisplayString(_ctx.notification.content), 1 /* TEXT */))
                            ])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }),
                _cache[69] || (_cache[69] = _createTextVNode())
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"]),
        _cache[72] || (_cache[72] = _createTextVNode()),
        _createVNode(_component_StatusOverlayComponent, {
            visible: _ctx.loading,
            message: "Loading..."
        }, null, 8 /* PROPS */, ["visible"])
    ]));
}
